var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBillingAndCost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10971_32383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 15.75V3.75C3.75 3.35218 3.90804 2.97064 4.18934 2.68934C4.47064 2.40804 4.85218 2.25 5.25 2.25H12.75C13.1478 2.25 13.5294 2.40804 13.8107 2.68934C14.092 2.97064 14.25 3.35218 14.25 3.75V15.75L12 14.25L10.5 15.75L9 14.25L7.5 15.75L6 14.25L3.75 15.75Z",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1 5.99987C10.9641 5.76419 10.7667 5.5699 10.5289 5.43779C10.2911 5.30568 10.0219 5.24072 9.75 5.24987H8.25C7.85218 5.24987 7.47064 5.40791 7.18934 5.68921C6.90804 5.97052 6.75 6.35205 6.75 6.74987C6.75 7.1477 6.90804 7.52923 7.18934 7.81053C7.47064 8.09184 7.85218 8.24987 8.25 8.24987H9.75C10.1478 8.24987 10.5294 8.40791 10.8107 8.68921C11.092 8.97052 11.25 9.35205 11.25 9.74987C11.25 10.1477 11.092 10.5292 10.8107 10.8105C10.5294 11.0918 10.1478 11.2499 9.75 11.2499H8.25C7.97812 11.259 7.70887 11.1941 7.47106 11.062C7.23326 10.9298 7.03586 10.7356 6.9 10.4999",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 4.5V12",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10971_32383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingAndCost);
export default __webpack_public_path__ + "static/media/BillingAndCost.2fd36017f012759649181d7108da2a4b.svg";
export { ForwardRef as ReactComponent };